import React from 'react';
import { Container } from 'react-bootstrap';
import { useLanguage } from '../contexts/LanguageContext';

const Footer: React.FC = () => {
  const { t } = useLanguage();

  return (
    <footer className="site-footer">
      <Container className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-2 text-center">
        <span className="footer-name">Ellinor Kantedal</span>
        <span>
          {t('home.subtitle')} &middot; &copy; {new Date().getFullYear()}
        </span>
      </Container>
    </footer>
  );
};

export default Footer;
